var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Fill"}},[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":"问卷填报","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('div',{staticClass:"pdf-panel"},[_c('iframe',{staticClass:"iframe-panel",attrs:{"src":_vm.questUrl,"width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }